import { ArrowForward } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { IconLink } from '@procureai/ui-mui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';
import { RouteId } from '~/routes';

import { DevelopmentTool, ToolResultComponent } from '.';

export const RunUpsertIntakeRequest: ToolResultComponent<
  DevelopmentTool.runUpsertIntakeRequest,
  undefined,
  { intakeChatSessionId: string | null }
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });
  const navigate = useNavigate();

  const handleContinue = useCallback(
    async (chatSessionId: string) => {
      navigate(RouteId.intakeDetail(chatSessionId), { state: { _target: false } });
    },
    [navigate],
  );

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`)} />;

    case 'output-available':
      if (!tool.output.intakeChatSessionId) {
        return <ChatToolErrorIndicator message={t(`error`)} />;
      } else {
        return (
          <ChatToolResultIndicator message={t(`result`)} defaultOpen={true} disabled={false}>
            <Stack direction="row" spacing={2}>
              <IconLink
                color="text.primary"
                variant="body2"
                endIcon={<ArrowForward color="inherit" fontSize="small" />}
                sx={{ ':hover': { cursor: 'pointer' } }}
                onClick={() => handleContinue(tool.output.intakeChatSessionId!)}
              >
                {t(`continueCTA`)}
              </IconLink>
            </Stack>
          </ChatToolResultIndicator>
        );
      }
  }
};
